$(function () {
  // Keep the POS header visible: the modal starts right below it
  function positionTicketSalesModal() {
    const $header = $('header.header').first();
    const headerBottom = $header.length
      ? Math.max(0, $header[0].getBoundingClientRect().bottom)
      : 0;
    $('#ticket-sales-modal').css({
      top: headerBottom + 'px',
      height: 'calc(100% - ' + headerBottom + 'px)',
    });
  }

  $(document).on('click', '.ticket-sales-button', function () {
    const $iframe = $('#ticket-sales-iframe');
    if (!$iframe.length) {
      return;
    }

    // Load the shop fresh on every open so a previous customer's session is not shown
    $iframe.attr('src', $iframe.attr('data-src'));
    positionTicketSalesModal();
    $('#ticket-sales-modal').modal('show');
  });

  $(window).on('resize', function () {
    if ($('#ticket-sales-modal').hasClass('show')) {
      positionTicketSalesModal();
    }
  });

  $(document).on('hidden.bs.modal', '#ticket-sales-modal', function () {
    $('#ticket-sales-iframe').attr('src', 'about:blank');
  });
});
